import { render, staticRenderFns } from "./VvModal.vue?vue&type=template&id=f0db3560&scoped=true&"
import script from "./VvModal.vue?vue&type=script&lang=js&"
export * from "./VvModal.vue?vue&type=script&lang=js&"
import style0 from "./VvModal.vue?vue&type=style&index=0&id=f0db3560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0db3560",
  null
  
)

export default component.exports